import React, { useEffect, useState } from "react";
import {
  Container,
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  Avatar,
  Alert,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PCMCHeader from "../layout/pcmc-header";
import { validateUser } from "../../services/user";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getUserDetails, setSession } from "../../utils/sessionUtils";
import Loader from "../loader/loader";
import { getErrorMsg } from "../../utils/helpers";
import { errorMsg } from "../../utils/constants";
import { showToastError, showToastSuccess } from "../common/toastHelper";
import { LoginOutlined, Replay } from "@mui/icons-material";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [initialLoad, setInitialLoad] = useState(true);

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  // useEffect(() => {
  //   dispatch({ type: "RESET" });
  // }, [dispatch]);

  useEffect(() => {
    const userDetails = getUserDetails();
    if (userDetails?.otpverified) {
      setInitialLoad(false);
      navigate("/home");
    } else {
      setInitialLoad(false);
      setLoading(false);
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setError("");
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { username, password } = formData;
    setLoading(true);
    // Here, you would call your API with the form data
    validateUser(username, password)
      .then((data) => {
        if (data?.valid) {
          showToastSuccess();
          dispatch({
            type: "SET_USER_INFO",
            payload: data,
          });
          const {
            gatKey,
            profileId,
            profileName,
            userCode,
            userId,
            userName,
            zoneKey,
            otpverified,
            valid,
            emailAddress,
            counterKey,
          } = data;
          const sessionData = {
            gatKey,
            profileId,
            profileName,
            userCode,
            userId,
            userName,
            zoneKey,
            otpverified,
            valid,
            emailAddress,
            counterKey,
          };
          setSession(sessionData);
          navigate("/verify-otp");
        }
      })
      .catch((error) => {
        // setError(getErrorMsg(error));
        showToastError(getErrorMsg(error));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (initialLoad) {
    return null; // Return null while checking user details
  }

  const isSignInDisabled = !formData.username || !formData.password;
  return (
    <>
      <PCMCHeader />
      {loading && <Loader message="Verifying User..." />}
      <Container component="main" maxWidth="xs">
        <Box
          sx={{
            marginTop: 8,
            marginBottom: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            border: "2px solid #ccc",
            borderRadius: 2,
            p: 3,
            boxShadow: 3,
            bgcolor: "background.paper",
          }}
        >
          {error && <Alert severity="error">{error || errorMsg}</Alert>}
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Login
          </Typography>
          <Box
            component="form"
            noValidate
            sx={{ mt: 1 }}
            onSubmit={handleSubmit}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  autoFocus
                  variant="outlined"
                  required
                  fullWidth
                  id="username"
                  label="Enter username"
                  name="username"
                  autoComplete="username"
                  value={formData.username}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  name="password"
                  value={formData.password}
                  label="Enter password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  disabled={isSignInDisabled}
                  endIcon={<LoginOutlined />}
                >
                  Sign In
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="reset"
                  fullWidth
                  variant="outlined"
                  endIcon={<Replay />}
                  onClick={() => {
                    setFormData({ username: "", password: "" });
                  }}
                >
                  Reset
                </Button>
              </Grid>
              {/* <Grid item xs={12}>
                <Grid container justifyContent="space-between">
                  <Grid item>
                    <Link href="#" variant="body2">
                      Forgot password?
                    </Link>
                  </Grid>
                  <Grid item>
                    <Link href="#" variant="body2">
                      {"Don't have an account? Sign Up"}
                    </Link>
                  </Grid>
                </Grid>
              </Grid> */}
            </Grid>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default Login;
